var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-content-information",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id',
    isI18nMs: _vm.$i18n.locale == 'ms',
    isI18nTh: _vm.$i18n.locale == 'th',
    isI18nZh: _vm.$i18n.locale == 'zh'
  }},[_vm._l((_vm.list),function(data,index1){return [_c('div',{key:index1,staticClass:"info-box"},[_c('div',{staticClass:"info-label"},[_vm._v(_vm._s(data.label))]),_c('div',{staticClass:"info-values"},_vm._l((data.values),function(value,index2){return _c('div',{key:index2,staticClass:"info-value"},[_vm._v(_vm._s(value))])}),0)])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }